/**
 * Electrically-valid pin sets for the ESP32 (classic, DevKit V1 pinout).
 *
 * Encodes real hardware constraints into the editor:
 *  - GPIO 6-11 are wired to integrated flash and must never be exposed.
 *  - GPIO 34-39 are input-only (no output drivers, no pull resistors on 34-39).
 *  - ADC2 pins (0, 2, 4, 12-15, 25-27) cannot be used with Wi-Fi active;
 *    analog read therefore only offers ADC1 pins.
 */

export const OUTPUT_PINS = [
  0, 1, 2, 4, 5, 12, 13, 14, 15, 16, 17, 18, 19, 21, 22, 23, 25, 26, 27, 32, 33,
];

export const INPUT_PINS = [
  0, 1, 2, 3, 4, 5, 12, 13, 14, 15, 16, 17, 18, 19, 21, 22, 23, 25, 26, 27, 32, 33, 34, 35, 36, 39,
];

export const ADC1_PINS = [32, 33, 34, 35, 36, 39];

export const INPUT_PULL_CAPABLE_PINS = [
  0, 1, 2, 3, 4, 5, 12, 13, 14, 15, 16, 17, 18, 19, 21, 22, 23, 25, 26, 27, 32, 33,
];

/** ADC2 channels — illegal for analogRead while Wi-Fi is on; used by the checker. */
export const ADC2_PINS = [0, 2, 4, 12, 13, 14, 15, 25, 26, 27];

/** RTC-domain GPIOs usable for EXT0/EXT1 deep-sleep wakeup and RTC interrupts. */
export const RTC_GPIO_PINS = [0, 2, 4, 12, 13, 14, 15, 25, 26, 27, 32, 33, 34, 35, 36, 39];

export const DEFAULT_I2C_SDA = 21;
export const DEFAULT_I2C_SCL = 22;
export const DEFAULT_UART2_RX = 16;
export const DEFAULT_UART2_TX = 17;

/** Default VSPI header pins on DevKit boards. */
export const DEFAULT_SPI_SCK = 18;
export const DEFAULT_SPI_MISO = 19;
export const DEFAULT_SPI_MOSI = 23;
export const DEFAULT_SPI_CS = 5;

function options(pins: number[]): [string, string][] {
  return pins.map((p) => [`GPIO ${p}`, String(p)]);
}

export const OUTPUT_PIN_OPTIONS = options(OUTPUT_PINS);
export const INPUT_PIN_OPTIONS = options(INPUT_PINS);
export const ADC1_PIN_OPTIONS = options(ADC1_PINS);
export const PULL_PIN_OPTIONS = options(INPUT_PULL_CAPABLE_PINS);
export const ALL_PIN_OPTIONS = options(INPUT_PINS);
export const RTC_GPIO_OPTIONS = options(RTC_GPIO_PINS);
